import axios from 'api/axios'
import { get, post } from 'store/api'
import { jwtDecode } from 'jwt-decode'
import { getUsersByNameRepository, getUsersRepository, removeUsersRepository } from 'repositories/users'

export const USER_TYPE_ADMIN = 0
export const ROLE_ADMINISTRATOR = 1
export const ROLE_REDACTOR = 2
export const ROLE_ANALYTIC = 3
export const ROLE_EXTERNAL_EDITOR = 4

export const getClients = async () => {
  const { data: clients } = await get(`${process.env.REACT_APP_HEADERS_DOMAIN}/api/clients?paginate=150`)
  return clients
}

export const getClientHasAmazonClients = async ({ clientId }) => {
  if (!clientId) throw new Error('clientId is required')
  return axios.get(`${process.env.REACT_APP_HEADERS_DOMAIN}/api/${clientId}/amazon_credential_client/check`)
}

export const login = async (data) => {
  const response = await post(`${process.env.REACT_APP_HEADERS_DOMAIN}/api/auth/login`, data)
  localStorage.setItem('bearer', `Bearer ${response.accessToken}`)
  try {
    const clients = await getClients()
    if (clients) {
      response.clients = clients
    } else {
      response.clients = []
    }
  } catch (error) {
    console.log(error)
  }
  const decoded = jwtDecode(response.accessToken)
  response.userType = decoded.userType
  return response
}

export const setMailToRecoverPassword = async (data) => post(`${process.env.REACT_APP_HEADERS_DOMAIN}/api/auth/reset-password`, data)

export const userInfo = async () => post(`${process.env.REACT_APP_HEADERS_DOMAIN}/api/auth/me`)

export const updateRecoverPassword = async (data) => axios.post(`${process.env.REACT_APP_HEADERS_DOMAIN}/api/auth/change-password`, data)

export const getUsersByName = async (searchValue) => {
  const result = await getUsersByNameRepository(searchValue)
  return result?.data
}
export const getUsers = async (page, searchValue, clientsId) => {
  const result = await getUsersRepository(page, searchValue, clientsId)
  return result?.data
}

export const removeUser = async (user_id) => {
  const result = await removeUsersRepository(user_id)
  return result?.data
}
